export interface TreemapValue {
  label: string;
  value: number;
  unit: string;
}

export interface TreemapTile extends TreemapValue {
  id: number;
  x: number;
  y: number;
  width: number;
  height: number;
}

/** Balanced binary partition: every positive measure keeps its proportional area. */
export function treemapLayout(values: TreemapValue[]): TreemapTile[] {
  const items = values.map((value, id) => ({...value, id}))
    .filter(item => Number.isFinite(item.value) && item.value > 0)
    .sort((a, b) => b.value - a.value || a.id - b.id);
  const result: TreemapTile[] = [];
  const partition = (nodes: typeof items, x: number, y: number, width: number, height: number): void => {
    if (!nodes.length) return;
    if (nodes.length === 1) { result.push({...nodes[0], x, y, width, height}); return; }
    const total = nodes.reduce((sum, item) => sum + item.value, 0);
    let split = 1;
    let weight = nodes[0].value;
    while (split < nodes.length - 1 && Math.abs(weight + nodes[split].value - total / 2) < Math.abs(weight - total / 2)) {
      weight += nodes[split++].value;
    }
    const ratio = weight / total;
    // The default plot is approximately twice as wide as tall.
    if (width * 2 >= height) {
      partition(nodes.slice(0, split), x, y, width * ratio, height);
      partition(nodes.slice(split), x + width * ratio, y, width * (1 - ratio), height);
    } else {
      partition(nodes.slice(0, split), x, y, width, height * ratio);
      partition(nodes.slice(split), x, y + height * ratio, width, height * (1 - ratio));
    }
  };
  partition(items, 0, 0, 100, 100);
  return result;
}
